var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMypageIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0925 3.02719C15.1803 2.04234 13.9063 1.5 12.5 1.5C11.0863 1.5 9.80799 2.03906 8.90002 3.01781C7.98221 4.00734 7.53502 5.35219 7.64002 6.80437C7.84815 9.66937 10.0283 12 12.5 12C14.9717 12 17.1481 9.66984 17.3596 6.80531C17.466 5.36625 17.016 4.02422 16.0925 3.02719ZM20.75 22.5H4.25002C4.03405 22.5028 3.82017 22.4574 3.62394 22.3672C3.42772 22.2769 3.25407 22.1441 3.11565 21.9783C2.81096 21.6141 2.68815 21.1167 2.77909 20.6137C3.17471 18.4191 4.4094 16.5755 6.35002 15.2812C8.07409 14.1323 10.258 13.5 12.5 13.5C14.7421 13.5 16.926 14.1328 18.65 15.2812C20.5906 16.575 21.8253 18.4186 22.221 20.6133C22.3119 21.1162 22.1891 21.6136 21.8844 21.9778C21.746 22.1437 21.5724 22.2766 21.3762 22.367C21.1799 22.4573 20.966 22.5028 20.75 22.5Z",
    fill: "#11B55F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypageIcon2);
export default __webpack_public_path__ + "static/media/mypageIcon2.63cd6d41705111b8925c22189b1cbdb6.svg";
export { ForwardRef as ReactComponent };